var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38875 5.19354H8.28863C8.41069 5.19303 8.52985 5.15634 8.63106 5.0881C8.73226 5.01987 8.81096 4.92315 8.8572 4.81019C8.90344 4.69723 8.91515 4.5731 8.89084 4.45348C8.86653 4.33387 8.80731 4.22415 8.72064 4.13819L5.27687 0.694424C5.2195 0.636579 5.15124 0.590665 5.07603 0.559332C5.00083 0.528 4.92016 0.511869 4.83869 0.511869C4.75721 0.511869 4.67655 0.528 4.60134 0.559332C4.52613 0.590665 4.45787 0.636579 4.4005 0.694424L0.956731 4.13819C0.870068 4.22415 0.810839 4.33387 0.786532 4.45348C0.762225 4.5731 0.773932 4.69723 0.820173 4.81019C0.866414 4.92315 0.945113 5.01987 1.04632 5.0881C1.14752 5.15634 1.26669 5.19303 1.38875 5.19354Z",
    fill: "#EF4D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.e9d92ec068d668ec93f98c7826e52a13.svg";
export { ForwardRef as ReactComponent };